import { Link, useRouterState } from "@tanstack/react-router";
import {
  LayoutGrid, Building2, Users, CreditCard, ScrollText,
  Megaphone, Flag, Package, ShieldCheck,
} from "lucide-react";
import {
  Sidebar, SidebarContent, SidebarGroup, SidebarGroupContent,
  SidebarGroupLabel, SidebarHeader, SidebarMenu, SidebarMenuButton, SidebarMenuItem,
} from "@/components/ui/sidebar";

const items = [
  { title: "Overview", url: "/admin", icon: LayoutGrid, exact: true },
  { title: "Organizations", url: "/admin/organizations", icon: Building2 },
  { title: "Users", url: "/admin/users", icon: Users },
  { title: "Plans", url: "/admin/plans", icon: Package },
  { title: "Billing", url: "/admin/billing", icon: CreditCard },
  { title: "Audit Log", url: "/admin/audit", icon: ScrollText },
  { title: "Feature Flags", url: "/admin/feature-flags", icon: Flag },
  { title: "Announcements", url: "/admin/announcements", icon: Megaphone },
];

export function AdminSidebar() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  return (
    <Sidebar collapsible="icon" className="border-r border-border">
      <SidebarHeader className="p-4">
        <Link to="/admin" className="flex items-center gap-3 px-2 py-1">
          <div className="flex size-8 flex-none items-center justify-center rounded-md bg-foreground text-background">
            <ShieldCheck className="size-4" />
          </div>
          <div className="flex flex-col leading-tight group-data-[collapsible=icon]:hidden">
            <span className="text-sm font-semibold tracking-tight">Platform Admin</span>
            <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
              SuperAdmin · v1
            </span>
          </div>
        </Link>
      </SidebarHeader>
      <SidebarContent className="px-2">
        <SidebarGroup>
          <SidebarGroupLabel className="text-[10px] font-semibold uppercase tracking-widest text-muted-foreground/70">
            Operations
          </SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {items.map((item) => {
                const active = item.exact ? pathname === item.url : pathname.startsWith(item.url);
                return (
                  <SidebarMenuItem key={item.url}>
                    <SidebarMenuButton asChild isActive={active}>
                      <Link to={item.url} className="flex items-center gap-2">
                        <item.icon className="size-4" />
                        <span className="font-medium">{item.title}</span>
                      </Link>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                );
              })}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
